<template>
	<main>
		<Content>
			<template>
				<AboutContent/>
			</template>
		</Content>
	</main>
</template>

<script>
	import Content from '@/components/Content';
	import AboutContent from '@/components/content/AboutContent'

	export default {
		name: 'About',
		components: {
			Content,
			AboutContent,
		}
	}
</script>
